import { useEffect, useState } from "react";
import PageHeading from "../../components/PageElements/PageHeading";

import Table from "../../components/Tables/Table";
import {
  Form,
  Modal,
  Select,
  Space,
  Tag,
  Drawer,
  Tooltip,
  Divider,
  Tabs,
} from "antd";
import { FiEdit, FiTrash2 } from "react-icons/fi";
import toast from "react-hot-toast";
import TableHeader from "../../components/Tables/TableHeader";
import TextInput from "../../components/Inputs/TextInput";
import FormButton from "../../components/Buttons/FormButton";
import { Formik } from "formik";
import FormCancelButton from "../../components/Buttons/FormCancelButton";
import FormErrors from "../../components/Errors/FormErrors";
import DeleteModal from "../../components/Modals/DeleteModal";
import { IoIosWarning } from "react-icons/io";

import { CiBarcode } from "react-icons/ci";
import {
  MailOutlined,
  PhoneOutlined,
  EnvironmentOutlined,
  GlobalOutlined,
  FacebookFilled,
  LinkedinFilled,
  TagOutlined,
} from "@ant-design/icons";
import { BsPerson, BsTwitterX } from "react-icons/bs";
import { useNavigate } from "react-router-dom";

import {
  activateInstitution,
  createInstitution,
  deactivateInstitution,
  deleteInstitution,
  getInstitutions,
  updateInstitution,
} from "../../services/institutionService";
import { institutionSchema } from "../../validators/institutionValidators";
import CustomDropDownInput from "../../components/Inputs/CustomDropDownInput";
import { getInstitutionCategories } from "../../services/institutionCategory";
import ImageFileUpload from "../../components/Inputs/ImageFileUpload";
import { VITE_API_BASE_URL } from "../../config";
import InputPhone from "../../components/Inputs/InputPhone";
import { BiShow } from "react-icons/bi";
import { AiOutlineProfile } from "react-icons/ai";
import { CgDanger } from "react-icons/cg";
import { LiaRedoAltSolid } from "react-icons/lia";
import { getFocusAreas } from "../../services/focusAreaService";
import MultiSelectDropdown from "../../components/Inputs/MultiSelectDropDown";
import { getOwnerships } from "../../services/ownershipService";
import { getLicenseCategories } from "../../services/licenseCategoryService";

import LogoPlaceholder from "../../assets/logo-placeholder.png";
import DateInput from "../../components/Inputs/DateInput";
import { CiCalendarDate } from "react-icons/ci";
import { MdOutlineCenterFocusWeak, MdOutlinePerson2 } from "react-icons/md";
import { GrLicense } from "react-icons/gr";
import { districts } from "../../utils/districts";

const Institution = () => {
  const [institutions, setInstitutions] = useState([]);
  const [filteredInstitutions, setFilteredInstitutions] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [institutionToEdit, setInstitutionToEdit] = useState(null);
  const [modalText, setModalText] = useState("");
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [institutionToDelete, setInstitutionToDelete] = useState(null);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [errs, setErrs] = useState(null);
  const [institutionCategories, setInstitutionCategories] = useState([]);
  const [focusAreas, setFocusAreas] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("Not Selected");
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [selectedInstitution, setSelectedInstitution] = useState(null);

  const [isDeactivateModalOpen, setIsDeactivateModelOpen] = useState(false);
  const [institutionToDeactivate, setInstitutionToDeactivate] = useState(null);
  const [selectedFocusArea, setSelectedFocusArea] = useState("Not Selected");

  const [ownershipCategories, setOwnershipCategories] = useState([]);
  const [licensingCategories, setLicensingCategories] = useState([]);

  const [selectedOwnershipCategory, setSelectedOwnershipCategory] =
    useState("Not Selected");
  const [selectedLicensingCategory, setSelectedLicensingCategory] =
    useState("Not Selected");

  const [selectedSubscriptionStatus, setSelectedSubscriptionStatus] =
    useState("All");

  const [selectedLocation, setSelectedLocation] = useState("Not Selected");

  const [selectedRegion, setSelectedRegion] = useState("Not Selected");

  const navigate = useNavigate();

  useEffect(() => {
    loadInstitutions();
    loadCategories();
    loadfocusAreas();
    loadOwnershipCategories();
    loadLicensingCategories();
  }, []);

  useEffect(() => {
    let filtered = institutions;

    // Filter by name (searchTerm)
    if (searchTerm.trim() !== "") {
      filtered = filtered.filter((item) =>
        item.name?.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    // Filter by selected category
    if (selectedCategory !== "Not Selected") {
      filtered = filtered.filter(
        (item) => item.category?.id?.toString() === selectedCategory.toString()
      );
    }

    if (selectedOwnershipCategory !== "Not Selected") {
      filtered = filtered.filter(
        (item) =>
          item.ownership?.id?.toString() ===
          selectedOwnershipCategory.toString()
      );
    }

    if (selectedLicensingCategory !== "Not Selected") {
      filtered = filtered.filter(
        (item) =>
          item.license_category?.id?.toString() ===
          selectedLicensingCategory.toString()
      );
    }

    if (selectedFocusArea !== "Not Selected") {
      filtered = filtered.filter((item) =>
        item.focus_areas?.some(
          (area) => area.id?.toString() === selectedFocusArea.toString()
        )
      );
    }

    if (selectedSubscriptionStatus === "Expired") {
      filtered = filtered.filter((item) => {
        const today = new Date();
        const expiry = item.subscription_expiry_date
          ? new Date(item.subscription_expiry_date)
          : null;

        return expiry && expiry < today;
      });
    }

    if (selectedSubscriptionStatus === "Active") {
      filtered = filtered.filter((item) => {
        const today = new Date();
        const expiry = item.subscription_expiry_date
          ? new Date(item.subscription_expiry_date)
          : null;

        return expiry && expiry >= today;
      });
    }

    if (selectedLocation !== "Not Selected") {
      filtered = filtered.filter(
        (item) =>
          item.location?.toLowerCase() === selectedLocation.toLowerCase()
      );
    }

    if (selectedRegion !== "Not Selected") {
      filtered = filtered.filter(
        (item) => item.region?.toLowerCase() === selectedRegion.toLowerCase()
      );
    }

    setFilteredInstitutions(filtered);
  }, [
    searchTerm,
    institutions,
    selectedCategory,
    selectedOwnershipCategory,
    selectedFocusArea,
    selectedLicensingCategory,
    selectedSubscriptionStatus,
    selectedLocation,
    selectedRegion,
  ]);

  const loadCategories = async () => {
    setLoading(true);
    try {
      const { data } = await getInstitutionCategories();
      setInstitutionCategories(data.data);
    } catch (error) {
      toast.error(error?.response?.data?.error || "Failed to load categories");
    } finally {
      setLoading(false);
    }
  };

  const loadOwnershipCategories = async () => {
    setLoading(true);
    try {
      const { data } = await getOwnerships();
      setOwnershipCategories(data.data);
    } catch (error) {
      toast.error(
        error?.response?.data?.error || "Failed to ownership categories"
      );
    } finally {
      setLoading(false);
    }
  };

  const loadLicensingCategories = async () => {
    setLoading(true);
    try {
      const { data } = await getLicenseCategories();
      setLicensingCategories(data.data);
    } catch (error) {
      toast.error(
        error?.response?.data?.error || "Failed to licensing categories"
      );
    } finally {
      setLoading(false);
    }
  };

  const loadfocusAreas = async () => {
    setLoading(true);
    try {
      const { data } = await getFocusAreas();
      setFocusAreas(data.data);
    } catch (error) {
      toast.error(error?.response?.data?.error || "Failed to load focus areas");
    } finally {
      setLoading(false);
    }
  };

  const loadInstitutions = async () => {
    setLoading(true);
    try {
      const { data } = await getInstitutions();
      setInstitutions(data.data);
      setFilteredInstitutions(data.data);
    } catch (error) {
      toast.error(
        error?.response?.data?.error || "Failed to load Institutions"
      );
    } finally {
      setLoading(false);
    }
  };

  const onSubmit = (payload, resetForm) => {
    if (institutionToEdit) {
      onUpdateInstitution(payload, resetForm);
    } else {
      onCreateInstitution(payload, resetForm);
    }
  };

  const onCreateInstitution = async (payload, resetForm) => {
    setErrs(null);

    try {
      const { data } = await createInstitution(payload);

      setInstitutions((prev) => [...prev, data.data]);

      toast.success("Institution created successfully");

      setIsModalOpen(false);

      resetForm();
    } catch (error) {
      const { response } = error;
      if (response && response.status === 422) {
        setErrs(response.data.errors);
      } else {
        toast.error(
          response.data.error || "Institution was not created, try again!"
        );
      }
    }
  };

  const handleEdit = (category) => {
    setInstitutionToEdit(category);
    setIsModalOpen(true);
  };

  const onUpdateInstitution = async (payload, resetForm) => {
    setErrs(null);

    const formData = new FormData();

    formData.append("_method", "PATCH");
    formData.append("name", payload.name);
    formData.append("code", payload.code);
    formData.append("establishment_year", payload.establishment_year);
    formData.append("region", payload.region);
    formData.append("website_url", payload.website_url);
    formData.append("facebook", payload.facebook);
    formData.append("linkedin", payload.linkedin);
    formData.append("twitter", payload.twitter);
    formData.append("email", payload.email);
    formData.append("location", payload.location);
    formData.append("contact", payload.contact);
    formData.append("institution_category_id", payload.institution_category_id);
    formData.append("ownership_id", payload.ownership_id);
    formData.append("license_category_id", payload.license_category_id);
    formData.append("vc_name", payload.vc_name);

    formData.append(
      "subscription_expiry_date",
      payload.subscription_expiry_date
    );

    if (Array.isArray(payload.focus_areas)) {
      payload.focus_areas.forEach((areaId) => {
        formData.append("focus_areas[]", areaId);
      });
    }

    if (typeof payload.logo !== "string") {
      formData.append("logo", payload.logo);
    }

    try {
      const originalInstitutions = [...institutions];

      const institutionIndex = originalInstitutions.findIndex(
        (institution) => institution.id === institutionToEdit.id
      );

      if (institutionIndex === -1) throw new Error("Institution not found.");

      const { data } = await updateInstitution(institutionToEdit.id, formData);

      originalInstitutions[institutionIndex] = data.data;

      setInstitutions(originalInstitutions);

      setInstitutionToEdit(null);

      resetForm();

      setIsModalOpen(false);

      toast.success("Institution updated successfully!");
    } catch (error) {
      const { response } = error;
      if (response && response.status === 422) {
        setErrs(response.data.errors);
      } else {
        toast.error(
          response?.data?.error || "Institution not updated, try again!"
        );
      }
    }
  };

  const handleDelete = (payload) => {
    setModalText(
      `Please confirm that you want to delete %${payload?.name?.toUpperCase()}`
    );
    setInstitutionToDelete(payload);
    setIsDeleteModalOpen(true);
  };

  const onDeleteInstitution = async () => {
    const originalInstitutions = [...institutions];

    const newInstitutions = originalInstitutions.filter(
      (institution) => institution.id !== institutionToDelete.id
    );

    setInstitutions(newInstitutions);

    try {
      await deleteInstitution(institutionToDelete?.id);

      toast.success("Institution deleted successfully!");
    } catch (error) {
      console.log("Error", error);

      const { response } = error;
      toast.error(
        ` ${
          response?.data?.message ||
          error?.response?.data?.error ||
          "Institution not deleted, try again later"
        }`
      );

      setInstitutions(originalInstitutions);
    } finally {
      setIsDeleteModalOpen(false);

      setInstitutionToDelete(null);
    }
  };

  const handleView = (institutionData) => {
    navigate(`/admin/institutions/${institutionData.id}/profile`);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setIsDeleteModalOpen(false);
    setInstitutionToEdit(null);
    setInstitutionToDelete(null);
    setIsDeactivateModelOpen(false);
    setErrs(null);
  };

  const onDeactivateInstitution = async () => {
    const originalInstitutions = [...institutions];

    try {
      await deactivateInstitution(institutionToDeactivate?.id);

      const updatedInstitutions = originalInstitutions.map((institution) =>
        institution.id === institutionToDeactivate.id
          ? { ...institution, membership_status: false }
          : institution
      );

      setInstitutions(updatedInstitutions);

      toast.success("Institution deactivated successfully!");
    } catch (error) {
      const { response } = error;
      toast.error(
        response?.data?.message ||
          "Institution not deactivated, try again later"
      );
      setInstitutions(originalInstitutions);
    } finally {
      setIsDeactivateModelOpen(false);
      setInstitutionToDeactivate(null);
    }
  };

  const onActivateInstitution = async (data) => {
    const originalInstitutions = [...institutions];
    try {
      await activateInstitution(data.id);

      const updatedInstitutions = originalInstitutions.map((institution) =>
        institution.id === data.id
          ? { ...institution, membership_status: true }
          : institution
      );
      setInstitutions(updatedInstitutions);
      toast.success("Institution activated successfully!");
    } catch (error) {
      const { response } = error;
      toast.error(
        response?.data?.message || "Institution not activated, try again later"
      );
      setInstitutions(originalInstitutions);
    } finally {
    }
  };

  const handleOpenTestModal = (data) => {
    setIsDeactivateModelOpen(true);

    setInstitutionToDeactivate(data);

    setModalText(
      `Please confirm that you want to de-activate %${data?.name.toUpperCase()}`
    );
  };

  const handleOkDeactivate = () => {
    onDeactivateInstitution();
    setConfirmLoading(true);
    setTimeout(() => {
      setIsModalOpen(false);
      setIsDeactivateModelOpen(false);
      setConfirmLoading(false);
    }, 100);
  };

  const activeInstitutions = filteredInstitutions.filter(
    (institution) => institution.membership_status
  );
  const deactivatedInstitutions = filteredInstitutions.filter(
    (institution) => !institution.membership_status
  );

  const columns = [
    {
      title: "#",
      render: (text, record, index) => index + 1,
      width: 70,
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Code",
      dataIndex: "code",
      key: "code",
      width: 120,
    },

    {
      title: "Status Category",
      dataIndex: "category",
      key: "category",
      render: (_, record) => (
        <Tag color="magenta" className="ml-1">
          {record.category?.name || "N/A"}
        </Tag>
      ),
      width: 180,
    },

    {
      title: "Licensing Category",
      dataIndex: "license_category",
      key: "license_category",
      render: (_, record) => (
        <Tag color="blue" className="ml-1">
          {record.license_category?.name || "N/A"}
        </Tag>
      ),
      width: 180,
    },

    {
      title: "Ownership Type",
      dataIndex: "ownership",
      key: "ownership",
      render: (_, record) => (
        <Tag color="cyan" className="ml-1">
          {record.ownership?.name || "N/A"}
        </Tag>
      ),
      width: 180,
    },

    {
      title: "Focus Areas",
      dataIndex: "focus_areas",
      key: "focus_areas",
      width: 300,
      render: (focusAreas) =>
        focusAreas && focusAreas.length > 0 ? (
          <Space wrap>
            {focusAreas.map((area) => (
              <Tag key={area.id} color="blue">
                {area.name}
              </Tag>
            ))}
          </Space>
        ) : (
          <span className="text-gray-400 italic">None</span>
        ),
    },
    {
      title: "VC/Principal",
      dataIndex: "vc_name",
      key: "vc_name",
    },
    {
      title: "Status",
      render: (_, record) => (
        <Tag color={record.membership_status ? "green" : "red"}>
          {record.membership_status ? "Active" : "Inactive"}
        </Tag>
      ),
    },

    {
      title: "Subscription Expiry",
      dataIndex: "subscription_expiry_date",
      key: "subscription_expiry_date",
    },

    {
      title: "Subscription Status",
      key: "subscription_status",
      render: (_, record) => {
        const today = new Date();
        const expiry = record.subscription_expiry_date
          ? new Date(record.subscription_expiry_date)
          : null;

        if (!expiry) return <Tag color="default">No Date</Tag>;

        return expiry < today ? (
          <Tag color="red">Expired</Tag>
        ) : (
          <Tag color="green">Active</Tag>
        );
      },
    },

    {
      title: "Action",
      key: "action",
      fixed: "right",
      width: 160,
      render: (_, record) => (
        <Space size="middle">
          <Tooltip title="View Institution Profile">
            <button
              className="p-2 border border-amber-400 rounded-md text-amber-600 hover:bg-amber-50 transition cursor-pointer"
              onClick={() => handleView(record)}
            >
              <AiOutlineProfile size={16} />
            </button>
          </Tooltip>
          <Tooltip title="View Institution">
            <button
              className="p-2 border border-blue-200 rounded-md text-blue-600 hover:bg-blue-50 transition cursor-pointer"
              onClick={() => {
                setSelectedInstitution(record);
                setIsDrawerOpen(true);
              }}
            >
              <BiShow size={16} />
            </button>
          </Tooltip>
          <Tooltip title="Edit Institution">
            <button
              className="p-2 border border-green-200 rounded-md text-green-600 hover:bg-green-50 transition cursor-pointer"
              onClick={() => handleEdit(record)}
            >
              <FiEdit size={16} />
            </button>
          </Tooltip>
          <Tooltip title="Deactivate Institution">
            <button
              onClick={() => handleOpenTestModal(record)}
              className="border-yellow-200 text-yellow-600 text-md hover:bg-yellow-50 p-2 border-[1px] rounded-md cursor-pointer"
            >
              <CgDanger />
            </button>
          </Tooltip>
          <Tooltip title="Delete Institution">
            <button
              className="p-2 border border-red-200 rounded-md text-red-500 hover:bg-red-50 transition cursor-pointer"
              onClick={() => handleDelete(record)}
            >
              <FiTrash2 size={16} />
            </button>
          </Tooltip>
        </Space>
      ),
    },
  ];

  const deactivtedColumns = [
    {
      title: "#",
      render: (text, record, index) => index + 1,
      width: 70,
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Code",
      dataIndex: "code",
      key: "code",
      width: 120,
    },

    {
      title: "Status Category",
      dataIndex: "category",
      key: "category",
      render: (_, record) => (
        <Tag color="magenta-inverse" className="ml-1">
          {record.category?.name || "N/A"}
        </Tag>
      ),
      width: 180,
    },

    {
      title: "Licensing Category",
      dataIndex: "license_category",
      key: "license_category",
      render: (_, record) => (
        <Tag color="blue-inverse" className="ml-1">
          {record.license_category?.name || "N/A"}
        </Tag>
      ),
      width: 180,
    },

    {
      title: "Ownership Type",
      dataIndex: "ownership",
      key: "ownership",
      render: (_, record) => (
        <Tag color="cyan-inverse" className="ml-1">
          {record.ownership?.name || "N/A"}
        </Tag>
      ),
      width: 180,
    },
    {
      title: "Focus Areas",
      dataIndex: "focus_areas",
      key: "focus_areas",
      width: 200,
      render: (focusAreas) =>
        focusAreas && focusAreas.length > 0 ? (
          <Space wrap>
            {focusAreas.map((area) => (
              <Tag key={area.id} color="blue">
                {area.name}
              </Tag>
            ))}
          </Space>
        ) : (
          <span className="text-gray-400 italic">None</span>
        ),
    },

    {
      title: "VC/Principal",
      dataIndex: "vc_name",
      key: "vc_name",
    },

    {
      title: "Status",
      render: (_, record) => (
        <Tag color={record.membership_status ? "green" : "red"}>
          {record.membership_status ? "Active" : "Inactive"}
        </Tag>
      ),
    },

    {
      title: "Subscription Expiry",
      dataIndex: "subscription_expiry_date",
      key: "subscription_expiry_date",
    },

    {
      title: "Subscription Status",
      key: "subscription_status",
      render: (_, record) => {
        const today = new Date();
        const expiry = record.subscription_expiry_date
          ? new Date(record.subscription_expiry_date)
          : null;

        if (!expiry) return <Tag color="default">No Date</Tag>;

        return expiry < today ? (
          <Tag color="red">Expired</Tag>
        ) : (
          <Tag color="green">Active</Tag>
        );
      },
    },

    {
      title: "Action",
      key: "action",
      width: 160,
      fixed: "right",
      render: (_, record) => (
        <Space size="middle">
          <Tooltip title="View Institution Profile">
            <button
              className="p-2 border border-amber-400 rounded-md text-amber-600 hover:bg-amber-50 transition cursor-pointer"
              onClick={() => handleView(record)}
            >
              <AiOutlineProfile size={16} />
            </button>
          </Tooltip>
          <Tooltip title="View Institution">
            <button
              className="p-2 border border-blue-200 rounded-md text-blue-600 hover:bg-blue-50 transition cursor-pointer"
              onClick={() => {
                setSelectedInstitution(record);
                setIsDrawerOpen(true);
              }}
            >
              <BiShow size={16} />
            </button>
          </Tooltip>
          <Tooltip title="Edit Institution">
            <button
              className="p-2 border border-green-200 rounded-md text-green-600 hover:bg-green-50 transition cursor-pointer"
              onClick={() => handleEdit(record)}
            >
              <FiEdit size={16} />
            </button>
          </Tooltip>
          <Tooltip title="Activate Institution">
            <button
              onClick={() => onActivateInstitution(record)}
              className=" text-green-600 border-green-200 text-md p-2 border-[1px] hover:bg-green-50 rounded-md cursor-pointer"
            >
              <LiaRedoAltSolid className="rotate-180" />
            </button>
          </Tooltip>
          <Tooltip title="Delete Institution">
            <button
              className="p-2 border border-red-200 rounded-md text-red-500 hover:bg-red-50 transition cursor-pointer"
              onClick={() => handleDelete(record)}
            >
              <FiTrash2 size={16} />
            </button>
          </Tooltip>
        </Space>
      ),
    },
  ];

  const uniqueRegions = districts.reduce((acc, curr) => {
    if (!acc.includes(curr.region)) {
      acc.push(curr.region);
    }
    return acc;
  }, []);
  const tabItems = [
    {
      key: 1,
      label: `Active Institutions (${activeInstitutions.length})`,
      children: (
        <Table
          isPaginable
          pageSize={10}
          isSearchable={false}
          loading={loading}
          columns={columns}
          rows={activeInstitutions.map((item) => ({
            ...item,
            key: item.id,
          }))}
          extra={
            <div className="grid gap-y-4 gap-x-3 grid-cols-1 md:grid-cols-5">
              <Select
                multiple={false}
                id="categories"
                defaultValue={selectedCategory}
                className="w-full h-[36px]"
                onChange={(value) => {
                  setSelectedCategory(value);
                }}
                showSearch={true}
                filterOption={(input, option) =>
                  option?.children
                    ?.toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                <Select.Option value={"Not Selected"}>
                  Filter by Category
                </Select.Option>
                {institutionCategories &&
                  institutionCategories.length > 0 &&
                  institutionCategories.map((option) => (
                    <Select.Option key={option.id} value={option.id}>
                      {option.name}
                    </Select.Option>
                  ))}
              </Select>

              <Select
                multiple={false}
                defaultValue={selectedFocusArea}
                className="w-full h-[36px]"
                onChange={(value) => setSelectedFocusArea(value)}
                showSearch
                filterOption={(input, option) =>
                  option?.children
                    ?.toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                <Select.Option value="Not Selected">
                  Filter by Focus Area
                </Select.Option>
                {focusAreas.map((option) => (
                  <Select.Option key={option.id} value={option.id}>
                    {option.name}
                  </Select.Option>
                ))}
              </Select>

              <Select
                multiple={false}
                defaultValue={selectedLicensingCategory}
                className="w-full h-[36px]"
                onChange={(value) => setSelectedLicensingCategory(value)}
                showSearch
                filterOption={(input, option) =>
                  option?.children
                    ?.toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                <Select.Option value="Not Selected">
                  Filter by Licensing Category
                </Select.Option>
                {licensingCategories &&
                  licensingCategories.length > 0 &&
                  licensingCategories.map((option) => (
                    <Select.Option key={option.id} value={option.id}>
                      {option.name}
                    </Select.Option>
                  ))}
              </Select>

              <Select
                multiple={false}
                id="ownership"
                defaultValue={selectedOwnershipCategory}
                className="w-full h-[36px]"
                onChange={(value) => {
                  setSelectedOwnershipCategory(value);
                }}
                showSearch={true}
                filterOption={(input, option) =>
                  option?.children
                    ?.toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                <Select.Option value={"Not Selected"}>
                  Filter by Ownership
                </Select.Option>
                {ownershipCategories &&
                  ownershipCategories.length > 0 &&
                  ownershipCategories.map((option) => (
                    <Select.Option key={option.id} value={option.id}>
                      {option.name}
                    </Select.Option>
                  ))}
              </Select>

              <Select
                defaultValue={selectedSubscriptionStatus}
                className="w-full h-[36px]"
                onChange={(value) => setSelectedSubscriptionStatus(value)}
              >
                <Select.Option value="All">
                  Filter by Subscription
                </Select.Option>
                <Select.Option value="Active">
                  Active Subscriptions
                </Select.Option>
                <Select.Option value="Expired">
                  Expired Subscriptions
                </Select.Option>
              </Select>

              <Select
                defaultValue={selectedLocation}
                className="w-full h-[36px]"
                onChange={(value) => setSelectedLocation(value)}
                showSearch
                filterOption={(input, option) =>
                  option?.children?.toLowerCase().includes(input.toLowerCase())
                }
              >
                <Select.Option value="Not Selected">
                  Filter by Location
                </Select.Option>
                {districts.map((district) => (
                  <Select.Option key={district.id} value={district.name}>
                    {district.name}
                  </Select.Option>
                ))}
              </Select>

              <Select
                defaultValue={selectedRegion}
                className="w-full h-[36px]"
                onChange={(value) => setSelectedRegion(value)}
                showSearch
                filterOption={(input, option) =>
                  option?.children?.toLowerCase().includes(input.toLowerCase())
                }
              >
                <Select.Option value="Not Selected">
                  Filter by Region
                </Select.Option>
                {uniqueRegions.map((region, index) => (
                  <Select.Option key={index} value={region}>
                    {region}
                  </Select.Option>
                ))}
              </Select>
            </div>
          }
        />
      ),
    },
    {
      key: 2,
      label: `Deactivated Institutions (${deactivatedInstitutions.length})`,
      children: (
        <Table
          isPaginable
          pageSize={10}
          isSearchable={false}
          loading={loading}
          columns={deactivtedColumns}
          rows={deactivatedInstitutions.map((item) => ({
            ...item,
            key: item.id,
          }))}
          extra={
            <div className="mb-2 py-2 flex gap-2">
              <Select
                multiple={false}
                id="categories"
                defaultValue={selectedCategory}
                className="w-full h-[36px]"
                onChange={(value) => {
                  setSelectedCategory(value);
                }}
                showSearch={true}
                filterOption={(input, option) =>
                  option?.children
                    ?.toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                <Select.Option value={"Not Selected"}>
                  Filter by Category
                </Select.Option>
                {institutionCategories &&
                  institutionCategories.length > 0 &&
                  institutionCategories.map((option) => (
                    <Select.Option key={option.id} value={option.id}>
                      {option.name}
                    </Select.Option>
                  ))}
              </Select>
            </div>
          }
        />
      ),
    },
  ];
  return (
    <>
      <PageHeading title="Institutions" subtitle1="Institutions" />

      <div className="px-8 py-6">
        <div className="bg-white shadow-sm rounded-lg p-6">
          <TableHeader
            title="Institution List"
            count={filteredInstitutions.length}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            buttonLabel="+ Add Institution"
            onButtonClick={() => setIsModalOpen(true)}
          />

          <Tabs defaultActiveKey="1" items={tabItems} type="card" />

          {/* Modal */}

          <Modal
            title={
              <div className="px-4 py-3">
                <h2 className="text-lg font-semibold text-gray-700">
                  {institutionToEdit ? "Edit Institution" : "Add Institution"}
                </h2>
              </div>
            }
            open={isModalOpen}
            onCancel={handleCancel}
            footer={false}
            width="100%"
            style={{
              top: 0,
              height: "100vh",
              maxWidth: "100vw",
              padding: 0,
            }}
            styles={{
              body: {
                height: "calc(100vh - 55px)",
                overflowY: "auto",
                padding: 24,
              },
              header: {
                padding: "16px 24px",
              },
            }}
          >
            <Formik
              initialValues={{
                name: institutionToEdit?.name ?? "",
                code: institutionToEdit?.code ?? "",
                logo: institutionToEdit?.logo ?? "",
                contact: institutionToEdit?.contact ?? "",
                email: institutionToEdit?.email ?? "",
                location: institutionToEdit?.location ?? "",
                institution_category_id: institutionToEdit?.category?.id ?? "",
                website_url: institutionToEdit?.website_url ?? "",
                facebook: institutionToEdit?.facebook ?? "",
                linkedin: institutionToEdit?.linkedin ?? "",
                twitter: institutionToEdit?.twitter ?? "",
                license_category_id:
                  institutionToEdit?.license_category?.id ?? "",
                ownership_id: institutionToEdit?.ownership?.id ?? "",
                subscription_expiry_date:
                  institutionToEdit?.subscription_expiry_date ?? "",
                establishment_year: institutionToEdit?.establishment_year ?? "",
                region: institutionToEdit?.region ?? "",
                focus_areas: institutionToEdit
                  ? institutionToEdit.focus_areas?.map((area) => area.id) || []
                  : [],
                vc_name: institutionToEdit?.vc_name ?? "",
              }}
              enableReinitialize
              validationSchema={institutionSchema}
              onSubmit={(values, { resetForm }) => {
                onSubmit(values, resetForm);
              }}
            >
              {({
                values,
                handleChange,
                handleBlur,
                errors,
                submitForm,
                setFieldValue,
                setFieldTouched,
                touched,
              }) => (
                <Form className="space-y-6 px-8! py-4!">
                  {errs && <FormErrors errors={errs} />}

                  {/* Institution Info */}
                  <div className="space-y-4">
                    <h3 className="text-base font-semibold text-gray-700 border-b border-gray-200 pb-3">
                      Institution Info
                    </h3>

                    {institutionToEdit?.logo && (
                      <div className="flex justify-center items-center w-full">
                        <div className="h-40 w-40">
                          <img
                            className="w-54 text-sm"
                            src={`${VITE_API_BASE_URL}/files/logos/${institutionToEdit?.logo}`}
                            alt={`Logo`}
                          />
                        </div>
                      </div>
                    )}

                    <ImageFileUpload
                      title="Attach Institution Logo"
                      name="logo"
                      requiredField={false}
                      errors={errors}
                      acceptedFiles="JPG, PNG up to 2 MB"
                      handleChange={handleChange}
                      setFieldValue={setFieldValue}
                    />

                    <div className="grid gap-x-3 grid-cols-1 md:grid-cols-3">
                      <TextInput
                        name="name"
                        title="Name"
                        requiredField
                        errors={errors}
                        values={values}
                        handleBlur={handleBlur}
                        handleChange={handleChange}
                      />
                      <TextInput
                        name="code"
                        title="Code"
                        requiredField
                        errors={errors}
                        values={values}
                        handleBlur={handleBlur}
                        handleChange={handleChange}
                      />
                      <TextInput
                        name="establishment_year"
                        title="Year of Establishment"
                        requiredField
                        errors={errors}
                        values={values}
                        handleBlur={handleBlur}
                        handleChange={handleChange}
                      />
                    </div>
                  </div>

                  {/* Classification */}
                  <div className="space-y-4">
                    <h3 className="text-base font-semibold text-gray-700 border-b border-gray-200 pb-3">
                      Classification
                    </h3>
                    <div className="grid gap-x-3 grid-cols-1 md:grid-cols-3">
                      <CustomDropDownInput
                        title="Category"
                        name="institution_category_id"
                        placeholder="Select Category"
                        errors={errors}
                        requiredField
                        options={institutionCategories}
                        handleBlur={handleBlur}
                        handleChange={handleChange}
                        values={values}
                        displayLabel={"name"}
                        idLabel="id"
                        setFieldValue={setFieldValue}
                        setFieldTouched={setFieldTouched}
                        showSearch
                      />
                      <CustomDropDownInput
                        title="Licensing Category"
                        name="license_category_id"
                        placeholder="Select Licensing Category"
                        errors={errors}
                        requiredField
                        options={licensingCategories}
                        handleBlur={handleBlur}
                        handleChange={handleChange}
                        values={values}
                        displayLabel={"name"}
                        idLabel="id"
                        setFieldValue={setFieldValue}
                        setFieldTouched={setFieldTouched}
                        showSearch
                      />
                      <CustomDropDownInput
                        title="Ownership Type"
                        name="ownership_id"
                        placeholder="Select Ownership Type"
                        errors={errors}
                        requiredField
                        options={ownershipCategories}
                        handleBlur={handleBlur}
                        handleChange={handleChange}
                        values={values}
                        displayLabel={"name"}
                        idLabel="id"
                        setFieldValue={setFieldValue}
                        setFieldTouched={setFieldTouched}
                        showSearch
                      />
                    </div>

                    <MultiSelectDropdown
                      title="Focus Areas"
                      name="focus_areas"
                      placeholder="Select Focus Areas"
                      errors={errors}
                      requiredField
                      options={focusAreas}
                      values={values.focus_areas || []}
                      displayLabel="name"
                      idLabel="id"
                      setFieldValue={setFieldValue}
                      setFieldTouched={setFieldTouched}
                      touched={touched}
                    />
                  </div>

                  {/* Location & Contact */}
                  <div className="space-y-4">
                    <h3 className="text-base font-semibold text-gray-700 border-b border-gray-200 pb-3">
                      Location & Contact
                    </h3>
                    <div className="grid gap-x-3 grid-cols-1 md:grid-cols-3">
                      <InputPhone
                        name="contact"
                        title="Phone Contact"
                        placeholder="77XXXXXXX"
                        errors={errors}
                        values={values}
                        handleBlur={handleBlur}
                        handleChange={handleChange}
                      />
                      <TextInput
                        name="email"
                        title="Email"
                        placeholder="Enter Email"
                        values={values}
                        handleBlur={handleBlur}
                        handleChange={handleChange}
                        errors={touched.email && errors.email}
                        touched={touched.email}
                      />
                      <CustomDropDownInput
                        title="Region"
                        requiredField
                        name="region"
                        placeholder="Select Region"
                        errors={errors}
                        options={uniqueRegions.map((region) => ({
                          name: region,
                        }))}
                        handleBlur={handleBlur}
                        handleChange={handleChange}
                        values={values}
                        displayLabel={"name"}
                        idLabel="name"
                        setFieldValue={setFieldValue}
                        setFieldTouched={setFieldTouched}
                      />
                      <CustomDropDownInput
                        title="District"
                        requiredField
                        name="location"
                        placeholder="Select District"
                        errors={errors}
                        options={districts}
                        handleBlur={handleBlur}
                        handleChange={handleChange}
                        values={values}
                        displayLabel={"name"}
                        idLabel="name"
                        setFieldValue={setFieldValue}
                        setFieldTouched={setFieldTouched}
                        showSearch
                      />
                      <TextInput
                        name="vc_name"
                        title="Vice Chancellor/Principal Name"
                        placeholder="Enter VC/Principal Name"
                        errors={errors}
                        values={values}
                        handleBlur={handleBlur}
                        handleChange={handleChange}
                      />
                    </div>
                  </div>

                  {/* Online Presence */}
                  <div className="space-y-4">
                    <h3 className="text-base font-semibold text-gray-700 border-b border-gray-200 pb-3">
                      Online Presence
                    </h3>
                    <div className="grid gap-x-3 grid-cols-1 md:grid-cols-3">
                      <TextInput
                        name="facebook"
                        title="Facebook"
                        placeholder="Enter Facebook URL"
                        errors={errors}
                        values={values}
                        handleBlur={handleBlur}
                        handleChange={handleChange}
                      />
                      <TextInput
                        name="website_url"
                        title="Website"
                        placeholder="Enter Website URL"
                        errors={errors}
                        values={values}
                        handleBlur={handleBlur}
                        handleChange={handleChange}
                      />
                      <TextInput
                        name="twitter"
                        title="Twitter"
                        placeholder="Enter Twitter URL"
                        errors={errors}
                        values={values}
                        handleBlur={handleBlur}
                        handleChange={handleChange}
                      />
                      <TextInput
                        name="linkedin"
                        title="LinkedIn"
                        placeholder="Enter LinkedIn URL"
                        errors={errors}
                        values={values}
                        handleBlur={handleBlur}
                        handleChange={handleChange}
                      />
                    </div>
                  </div>

                  {/* Subscription Details */}
                  <div className="space-y-4">
                    <h3 className="text-base font-semibold text-gray-700 border-b border-gray-200 pb-3">
                      Subscription Details
                    </h3>
                    <div className="grid gap-x-3 grid-cols-1 md:grid-cols-3">
                      <DateInput
                        name="subscription_expiry_date"
                        title="Subscription Expiry Date"
                        placeholder="Select Subscription Expiry Date"
                        errors={errors}
                        values={values}
                        touched={touched}
                        setFieldValue={setFieldValue}
                        setFieldTouched={setFieldTouched}
                      />
                    </div>
                  </div>

                  {/* Form Actions */}
                  <div className="flex justify-end gap-2">
                    <FormCancelButton text="Cancel" onClick={handleCancel} />
                    <FormButton
                      text="Save"
                      type="primary"
                      onClick={submitForm}
                    />
                  </div>
                </Form>
              )}
            </Formik>
          </Modal>

          <DeleteModal
            open={isDeleteModalOpen}
            handleOk={onDeleteInstitution}
            handleCancel={handleCancel}
            confirmLoading={confirmLoading}
            modalText={modalText}
            extra={
              <div className="mt-3 bg-red-100 text-red-500 border-[1px] border-red-300 mx-5 px-3 py-2 rounded-md">
                <h3 className="text-red-700 text-md flex gap-1 items-center">
                  <IoIosWarning /> Warning
                </h3>
                Please note that this action cannot be reversed!
              </div>
            }
          />

          <DeleteModal
            open={isDeactivateModalOpen}
            handleOk={handleOkDeactivate}
            handleCancel={handleCancel}
            confirmLoading={confirmLoading}
            modalText={modalText}
            okText={"Deactivate"}
          />

          <Drawer
            title={
              <div className="flex gap-2 items-center">
                <div className="flex gap-2 items-center w-24 h-24 px-2 py-1">
                  <img
                    className="w-24"
                    src={
                      selectedInstitution?.logo
                        ? `${VITE_API_BASE_URL}/files/logos/${selectedInstitution.logo}`
                        : LogoPlaceholder
                    }
                    alt="Logo"
                  />
                </div>
                <h1 className="text-lg uppercase">
                  {selectedInstitution?.name}
                </h1>
              </div>
            }
            width={520}
            onClose={() => setIsDrawerOpen(false)}
            open={isDrawerOpen}
            placement="right"
          >
            {selectedInstitution ? (
              <div className="text-gray-700 text-sm space-y-6 px-1">
                {/* Info */}
                <div className="grid grid-cols-1 gap-y-3">
                  <div className="flex items-center gap-2">
                    <TagOutlined />
                    <span className="font-medium">Category:</span>
                    <Tag color="magenta" className="ml-1">
                      {selectedInstitution.category?.name || "N/A"}
                    </Tag>
                  </div>

                  <div className="flex items-center gap-2">
                    <GrLicense />
                    <span className="font-medium">Licensing Category:</span>
                    <Tag color="blue" className="ml-1">
                      {selectedInstitution.license_category?.name || "N/A"}
                    </Tag>
                  </div>

                  <div className="flex items-center gap-2">
                    <MdOutlinePerson2 />
                    <span className="font-medium">Ownership Type:</span>
                    <Tag color="cyan" className="ml-1">
                      {selectedInstitution.ownership?.name || "N/A"}
                    </Tag>
                  </div>

                  <div className="flex items-center gap-2">
                    <CiBarcode />
                    <span className="font-medium">Code:</span>
                    <span>{selectedInstitution.code || "—"}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <BsPerson />
                    <span className="font-medium">VC/Principal:</span>
                    <span>{selectedInstitution.vc_name || "—"}</span>
                  </div>

                  <div className="flex items-center gap-2">
                    <CiCalendarDate />
                    <span className="font-medium">Establishment Year:</span>
                    <span>{selectedInstitution.establishment_year || "—"}</span>
                  </div>

                  <div className="flex items-center gap-2">
                    <EnvironmentOutlined />
                    <span className="font-medium">Region:</span>
                    <span>{selectedInstitution.region || "—"}</span>
                  </div>

                  <div className="flex items-center gap-2">
                    <EnvironmentOutlined className="text-orange-500" />
                    <span className="font-medium">Location:</span>
                    <span>{selectedInstitution.location || "—"}</span>
                  </div>

                  <div className="flex items-center gap-2">
                    <CiCalendarDate />
                    <span className="font-medium">
                      Subscription Expiry Date:
                    </span>
                    <span>{selectedInstitution?.subscription_expiry_date}</span>
                  </div>

                  <div className="flex items-center gap-2 flex-wrap">
                    <MdOutlineCenterFocusWeak className="text-purple-600" />
                    <span className="font-medium">Focus Areas:</span>
                    {Array.isArray(selectedInstitution.focus_areas) &&
                    selectedInstitution.focus_areas.length > 0 ? (
                      selectedInstitution.focus_areas.map((area) => (
                        <Tag key={area.id} color="blue" className="ml-1">
                          {area.name}
                        </Tag>
                      ))
                    ) : (
                      <span className="text-gray-400 italic">None</span>
                    )}
                  </div>

                  <div className="flex items-center gap-2">
                    <MailOutlined className="text-rose-500" />
                    <span className="font-medium">Email:</span>
                    <span>{selectedInstitution.email || "—"}</span>
                  </div>

                  <div className="flex items-center gap-2">
                    <PhoneOutlined className="text-green-600" />
                    <span className="font-medium">Contact:</span>
                    <span>{selectedInstitution.contact || "—"}</span>
                  </div>

                  <div className="flex items-center gap-2">
                    <GlobalOutlined className="text-blue-600" />
                    <span className="font-medium">Website:</span>
                    {selectedInstitution.website_url ? (
                      <a
                        href={selectedInstitution.website_url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-indigo-600 underline"
                      >
                        {selectedInstitution.website_url}
                      </a>
                    ) : (
                      <span>—</span>
                    )}
                  </div>
                </div>

                <Divider className="mt-2 mb-1" />

                {/* Socials */}
                <div className="space-y-3">
                  <h4 className="text-sm font-semibold text-gray-600">
                    Social Profiles
                  </h4>

                  {[
                    {
                      icon: <FacebookFilled className="text-blue-600" />,
                      label: "Facebook",
                      value: selectedInstitution.facebook,
                    },
                    {
                      icon: <BsTwitterX className="text-sky-500" />,
                      label: "Twitter",
                      value: selectedInstitution.twitter,
                    },
                    {
                      icon: <LinkedinFilled className="text-indigo-500" />,
                      label: "LinkedIn",
                      value: selectedInstitution.linkedin,
                    },
                  ].map(({ icon, label, value }) => (
                    <div className="flex items-center gap-2" key={label}>
                      {icon}
                      <span className="font-medium">{label}:</span>
                      {value ? (
                        <a
                          href={value}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-indigo-600 underline"
                        >
                          {value}
                        </a>
                      ) : (
                        <span className="text-gray-400">—</span>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              <p className="text-gray-500">No institution selected.</p>
            )}
          </Drawer>
        </div>
      </div>
    </>
  );
};

export default Institution;
